<template>
  <div class="main-page main-layout-field col-block width-full" :class="[windowType]">
    <div class="main-layout-container col-block" :style="{ height: (windowHeight - headerHeight) + 'px' }">
      <div class="main-layout-block col-block">
        <div class="main-layout-main-container" :class="['mobile'].includes(windowType) ? ['col-block', 'width-full'] : ['row-block', 'stretch']" :style="['mobile'].includes(windowType) ? {} : { flex: 1 }">
          <div class="main-announcement-container col-block width-full" :style="['mobile'].includes(windowType) ? {} : { width: '196px' }">
            <div class="main-announcement-header center-block">{{ ['mobile'].includes(windowType) ? 'Compass 衛⽣検査所'/* ___ */ : '' }}</div>
            <div class="main-announcement-block col-block width-full">
              <div class="main-announcement-table-container col-block width-full">
                <div class="main-announcement-table-block center-block">
                  <div class="main-announcement-table-title">{{ '最新ニュース'/* ___ */ }}</div>
                </div>
                <div class="main-announcement-table-block col-block width-full">
                  <div class="main-announcement-table-content-container col-block width-full">
                    <div class="main-announcement-table-content-block" :class="['mobile'].includes(windowType) ? ['content-block'] : ['col-block', 'flex-start']" v-for="(info, iindex) in announcementInfos['news']" :key="iindex">
                      <div class="main-announcement-table-content-title">{{ info.title }}</div>
                      <div class="main-announcement-table-content-separator"> | </div>
                      <div class="main-announcement-table-content-content">{{ info.content }}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="main-announcement-table-container col-block width-full">
                <div class="main-announcement-table-block center-block">
                  <div class="main-announcement-table-title">{{ 'カレンダー'/* ___ */ }}</div>
                </div>
                <div class="main-announcement-table-block col-block width-full">
                  <div class="main-announcement-table-content-container col-block width-full">
                    <div class="main-announcement-table-content-block col-block flex-start" v-for="(info, iindex) in announcementInfos['calendar']" :key="iindex">
                      <div class="main-announcement-table-content-title">{{ info.title }}</div>
                      <component
                        :is="(info.link || info.func) ? 'a' : 'div'"
                        class="main-announcement-table-content-content link main"
                        :href="info.link"
                        target="_blank"
                        @click="e => (info.func || (() => {}))(info)"
                      >{{ info.content }}</component>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div :style="{ flex: 1 }"></div>
            <div class="main-announcement-footer"></div>
          </div>
          <div class="main-container col-block width-full" :style="{ flex: 1 }">
            <div class="main-title-container col-block width-full">
              <div :style="{ height: ['mobile'].includes(windowType) ? '10px' : '10px' }"></div>
              <div class="main-title-info-container col-block" :class="[['mobile'].includes(windowType) ? '' : 'flex-end']">
                <div class="main-title-info-block col-block" :class="[['mobile'].includes(windowType) ? '' : 'flex-end']">
                  <div class="main-title-info row-block">
                    <span>{{ '登録番号︰第7新保衛医第270号'/* ___ */ }}</span>
                  </div>
                  <div class="main-title-info">
                    <span>{{ '検体提出方法および検体基準書'/* ___ */ }}</span>
                    <span>（<a class="link main" @click="e => downloadPDFFile('/pdf/検体提出方法および検体基準書.pdf', '検体提出方法および検体基準書.pdf')">PDF</a>）</span>
                  </div>
                </div>
              </div>
              <div :style="{ height: ['mobile'].includes(windowType) ? '10px' : '10px' }"></div>
              <mainTable
                :key="windowType"
                :layout="'head'"
                @download="(link, name) => downloadPDFFile(link, name)"
              ></mainTable>
            </div>
            <div class="main-content-container col-block width-full" :style="{ flex: 1 }">
              <mainTable
                :key="windowType"
                :layout="'body'"
                @download="(link, name) => downloadPDFFile(link, name)"
              ></mainTable>
            </div>
            <div class="main-footer-container col-block">
              <div :style="{ height: ['mobile'].includes(windowType) ? '10px' : '10px' }"></div>
              <div class="main-footer" v-html="footerInfo"></div>
              <div :style="{ height: ['mobile'].includes(windowType) ? '10px' : '10px' }"></div>
            </div>
          </div>
        </div>
        <div v-if="['mobile'].includes(windowType)" :style="{ flex: 1 }"></div>
      </div>
    </div>
  </div>
</template>

<script>
import mainTable from '@/components/main/table.vue'
import responsitiveData from '@/mixins/responsitiveData.vue'
import { downloadFile, generateHtmlElement } from '@/constants/global/util'

export default {
  components: {
    mainTable
  },
  mixins: [
    responsitiveData
  ],
  computed: {
    // static
    announcementInfos () {
      return {
        'news': [
          {
            title: '2026/3/25',
            content: '「自由診療」との項目名を「保険適用外の遺伝学的検査（自費）」へと変更いたしました。'
          },
          {
            title: '2026/3/25',
            content: '新增2026上半受付行事曆'
          },
          {
            title: '2026/3/25',
            content: '新增2026年6月改定により追加された検査項目'
          }
        ],
        'calendar': [
          {
            title: '2026/3/25',
            content: '2026年度上半期 検体受付・\n報告日程一覧',
            func: () => {
              this.downloadPDFFile('/pdf/2026年度上半期-A3_poster.pdf', '2026年度上半期-A3_poster.pdf')
            }
          }
        ]
      }
    },
    footerInfo () {
      let footerData = [
        {
          content: ['〒162-0056 東京都新宿区若松町2-2', 'TWIns3階N102'].join(['mobile'].includes(this.windowType) ? '\n' : ' ')/* ___ */
        },
        {
          content: '03-4446-3661',
          link: 'tel:+8144463661'
        }
      ]
      return footerData.map(data => {
        return [
          data.title ? generateHtmlElement('b', data.title) : null,
          generateHtmlElement(data.link ? 'a' : 'span', data.content, data.link ? { href: data.link, class: 'link main' } : '')
        ].filter(x => x).join('  ')
      }).join(['mobile'].includes(this.windowType) ? ' | ' : ' | ')
    }
  },
  methods: {
    downloadPDFFile (link, name) {
      if (name) {
        downloadFile(name, link, '_blank')
      } else {
        window.open(link, '_blank')
      }
    }
  }
}
</script>
